<template>
  <div>
    <div class="expand-item">
      <div class="item-title">
        <i class="el-icon-arrow-up expand-btn" :class="isOpen ? 'open' : ''" @click="isOpen = !isOpen"></i>
        <span class="title-content" @click="isOpen = !isOpen">{{ title }}</span>
      </div>
      <div class="item-conten" :class="isOpen ? 'open' : ''">
        <el-table v-if="data.length > 0" ref="multipleTable" :data="data" style="width: 100%" stripe :header-cell-style="{ background: '#DDEBFF' }" :height="tableHeight ? tableHeight : getHeight()">
          <el-table-column v-if="showRadio" width="40">
            <template slot-scope="scope">
              <el-radio class="table-radio" :label="scope.row" @change="selectChange"></el-radio>
            </template>
          </el-table-column>
          <template v-for="(item, index) in columns">
            <el-table-column :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width"></el-table-column>
          </template>
        </el-table>
        <!-- <div class="content-header">
          <template v-for="(item, index) in columns">
            <div
              class="header-column"
              :key="index"
              :style="{
                width: item.width + 'px',
                flexGrow: item.width == 'auto' ? '1' : 0,
                flexShrink: item.width == 'auto' ? '1' : 0,
              }"
            >
              {{ item.label }}
            </div>
          </template>
        </div>
        <div class="content-body">
          <template v-for="(item,index) in data">
            <div :key="index">
              {{item[]}}
            </div>
          </template>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
export default {
  components: {},
  /** 定义属性 */
  data () {
    return {
      isOpen: this.isExpand,
      tableHeight: "",
      selectedRadio: null,
    };
  },
  props: {
    data: {
      type: Array,
      default () {
        return [
          {
            id: 0,
            supplierName: "就发哈岁的",
            price: 100,
            number: 10,
          },
          {
            id: 1,
            supplierName: "就发哈岁的",
            price: 100,
            number: 10,
          },
          {
            id: 2,
            supplierName: "就发哈岁的",
            price: 100,
            number: 10,
          },
          {
            id: 3,
            supplierName: "就发哈岁的",
            price: 100,
            number: 10,
          },
          {
            id: 4,
            supplierName: "就发哈岁的",
            price: 100,
            number: 10,
          },
          {
            id: 5,
            supplierName: "就发哈岁的",
            price: 100,
            number: 10,
          },
          {
            id: 6,
            supplierName: "就发哈岁的",
            price: 100,
            number: 10,
          },
          {
            id: 7,
            supplierName: "就发哈岁的",
            price: 100,
            number: 10,
          },
          {
            id: 8,
            supplierName: "就发哈岁的",
            price: 100,
            number: 10,
          },
          {
            id: 9,
            supplierName: "就发哈岁的",
            price: 100,
            number: 10,
          },
        ];
      },
    },
    columns: {
      type: Array,
      default () {
        return [
          {
            label: "供应商",
            prop: "supplierName",
            width: "auto",
            align: "left",
          },
          {
            label: "单价",
            prop: "price",
            width: "auto",
            align: "left",
          },
          {
            label: "未建卡数量",
            prop: "number",
            width: "auto",
            align: "left",
          },
        ];
      },
    },
    showRadio: {
      type: Boolean,
      default () {
        return true;
      },
    },
    isExpand: {
      type: Boolean,
      default () {
        return false;
      },
    },
    dataKey: {
      type: String,
      default () {
        return "id";
      },
    },
    title: {
      type: String,
      default () {
        return "标题";
      },
    },
    pid: {
      type: String,
      default () {
        return "";
      },
    },
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {
    data (value) {
      this.getHeight();
    },
  },
  /** 方法集合 */
  methods: {
    getHeight () {
      let height = this.data.length * 44 + 32;
      if (height >= 332) {
        height = 332;
      }
      this.tableHeight = height + "px";
      return this.tableHeight;
    },
    selectChange (val) {
      // let item = this.data.find((t) => t[this.dataKey] == val.split("-")[1]);
      // this.$emit("selectChange", val.split("-")[0], item);
      this.$emit("selectChange", val);
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () { },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    this.getHeight();
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped>
.expand-item {
  .item-title {
    .expand-btn,
    .title-content {
      cursor: pointer;
    }
    .expand-btn {
      color: #286ab4;
      padding-right: 10px;
      transition: 0.5s;
      transform-origin: 7px 7px;
      transform: rotate(0deg);
    }
    .expand-btn.open {
      transform: rotate(180deg);
      transform-origin: 7px 7px;
      transition: 0.5s;
    }
    line-height: 25px;
  }
  .item-conten {
    overflow: hidden;
    overflow-x: auto;
    transition: max-height 0.5s;
    max-height: 0;
    .content-header {
      display: flex;
      width: auto;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      align-items: center;
      .header-column {
        line-height: 30px;
        padding: 0 10px;
        background: #e4e4e4;
      }
    }
  }
  .item-conten.open {
    max-height: 300px;
    transition: max-height 1s;
  }
}
/deep/.table-radio .el-radio__label {
  display: none;
}
</style>
